import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { NucleoResponse } from "../../../shared/response/proyectos/NucleoResponse";
import { NucleoPayload } from "../../../shared/services/api/payload/proyectos/NucleoPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { NucleoService, toNucleoResponse } from "./NucleoService";

/** Alta y edición de núcleos; el resultado reemplaza la fila del listado. */
export class NucleoSaveService extends ServiceSaveBase<NucleoResponse, NucleoPayload> {
  protected readonly cache = NucleoService.instance;

  /** gRPC-Web (`GuardarNucleo`). */
  protected async sendSave(p: NucleoPayload): Promise<NucleoResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).guardarNucleo({
      id: p.id ?? undefined,
      nombre: p.nombre,
      region: p.region,
      cultivoId: p.cultivoId ?? undefined,
      tecnicoId: p.tecnicoId ?? undefined,
      macroProyectoId: p.macroProyectoId ?? undefined,
      haMaxAsociacion: p.haMaxAsociacion ?? undefined,
      montoMaxReferencial: p.montoMaxReferencial !== null ? BigInt(Math.round(p.montoMaxReferencial)) : undefined,
    }));
    return toNucleoResponse(r);
  }
}
